import React from "react";
import {
    Card,
    CardContent,
    Typography,
    Box,
    Checkbox,
    FormControl,
    FormLabel,
    Select,
    Option,
    Input,
} from "@mui/joy";
import { TriangleRight } from "lucide-react";

import { SettingField, ESTIMATING_CONFIG } from "./EstimatingCommon";

interface ComplexityAdjustmentsProps {
    values: Record<string, any>;
    onChange: (key: string, value: any) => void;
}

export default function ComplexityAdjustments({ values, onChange }: ComplexityAdjustmentsProps) {
    const getSteepRate = () => {
        const type = values.EST_STEEP_TYPE as keyof typeof ESTIMATING_CONFIG.STEEP_RATES;
        return ESTIMATING_CONFIG.STEEP_RATES[type] || ESTIMATING_CONFIG.STEEP_RATES["7-9"];
    };

    return (
        <Card variant="soft" sx={{ border: "1px solid", borderColor: "divider" }}>
            <CardContent>
                <Typography level="title-sm" mb={2} startDecorator={<TriangleRight size={18} />}>
                    Complexity Adjustments
                </Typography>

                <Box
                    sx={{
                        p: 1.5,
                        bgcolor: "background.surface",
                        borderRadius: "md",
                        border: "1px solid",
                        borderColor: "divider",
                    }}
                >
                    <Checkbox
                        label="Steep Pitch Charge (> 7/12)"
                        checked={values.EST_STEEP_PITCH}
                        size="sm"
                        onChange={(e) => onChange("EST_STEEP_PITCH", e.target.checked)}
                        sx={{ mb: values.EST_STEEP_PITCH ? 2 : 0, pl: 0.5 }}
                    />
                    
                    {values.EST_STEEP_PITCH && (
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, pl: 3.5 }}>
                            <SettingField label="Steepness Level">
                                <Select
                                    size="sm"
                                    value={values.EST_STEEP_TYPE}
                                    onChange={(_, val) => onChange("EST_STEEP_TYPE", val)}
                                    sx={{ width: 200 }}
                                >
                                    {ESTIMATING_CONFIG.OPTIONS.STEEP_LEVELS.map((opt) => (
                                        <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                                    ))}
                                </Select>
                            </SettingField>

                            <SettingField label="Per SQ Rate">
                                <Input
                                    size="sm"
                                    startDecorator="$"
                                    readOnly
                                    value={getSteepRate()}
                                    type="number"
                                    sx={{ width: 100, bgcolor: "neutral.softBg" }}
                                />
                            </SettingField>
                        </Box>
                    )}
                </Box>
            </CardContent>
        </Card>
    );
}
